/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Not_FoundInputs */

const en_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume not found`)
};

const de_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf nicht gefunden`)
};

const fr_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV introuvable`)
};

const es_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum no encontrado`)
};

const it_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum non trovato`)
};

const nl_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV niet gevonden`)
};

const pl_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV nie znalezione`)
};

const fi_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluetteloa ei löytynyt`)
};

const da_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV ikke fundet`)
};

const sv_resumes_not_found = /** @type {(inputs: Resumes_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV hittades inte`)
};

/**
* | output |
* | --- |
* | "Resume not found" |
*
* @param {Resumes_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_not_found = /** @type {((inputs?: Resumes_Not_FoundInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Not_FoundInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_not_found(inputs)
	if (locale === "fr") return fr_resumes_not_found(inputs)
	if (locale === "es") return es_resumes_not_found(inputs)
	if (locale === "it") return it_resumes_not_found(inputs)
	if (locale === "nl") return nl_resumes_not_found(inputs)
	if (locale === "pl") return pl_resumes_not_found(inputs)
	if (locale === "fi") return fi_resumes_not_found(inputs)
	if (locale === "da") return da_resumes_not_found(inputs)
	if (locale === "sv") return sv_resumes_not_found(inputs)
	return en_resumes_not_found(inputs)
});